import {Locales} from '@netx/core-next/locales/utils/Locales';

export const AssetExpirationListLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.expiringAssets'),
}));

export const AssetExpirationActionLabel = Locales((i18n) => ({
	EXPIRE: i18n('i18n.expire'),
	UNEXPIRE: i18n('i18n.unexpire'),
}));

export const ASSET_EXPIRATION_CONFIRMATIONS = Locales((i18n) => ({
	UNEXPIRE: i18n('i18n.unexpireConfirm'),
}));

export const ASSET_EXPIRATION_SUBMIT_LABELS = Locales((i18n) => ({
	EXPIRE: i18n('i18n.expire'),
	UNEXPIRE: i18n('i18n.unexpire'),
}));

export const ASSET_EXPIRATION_TITLES = Locales((i18n) => ({
	EXPIRE: i18n('i18n.setExpiration'),
}));
